module.exports = __webpack_public_path__ + "img/BM.015c61bd.png";